import { configureStore } from "@reduxjs/toolkit";
import userDatasReducer from "./features/userDatasSlice";
import rolePermissionsReducer from "./features/rolePermissionsSlice";
import deviceDatasReducer from "./features/deviceDatasSlice";
import orderDatasReducer from "./features/orderDatasSlice";

const store = configureStore({
	reducer: {
		userDatas: userDatasReducer,
		rolePermissions: rolePermissionsReducer,
		deviceDatas: deviceDatasReducer,
		orderDatas: orderDatasReducer,
	},
});

export default store;
